import styles from './QuestionDescription.module.css';

export const QuestionDescription = ({ content }: { content: string }) => {
  return (
    <div className={styles.container}>
      <p className={styles.text}>{content}</p>
    </div>
  )
}